import { FC } from "react";
import styled from "styled-components";
import { Loader } from "../../components/loader";
import { Billing } from "../../store/billing/reducer";
import { useFetchable } from "../../store/common/fetchable";
import { toDecimal } from "../../utils/utils";
import { Icon } from "../icons";
import { Flex } from "../layout";

const Container = styled(Flex)`
  margin-right: 1em;
  justify-content: flex-end;
`;
const CoinIcon = styled(Icon).attrs({ type: "coin" })`
  margin-right: 0.2em;
`;

export interface CreditBalanceProps {
  className?: string;
}

export const CreditBalance: FC<CreditBalanceProps> = (props) => {
  const billingFetchable = useFetchable(Billing.balance);
  return (
    <Loader data={[billingFetchable]}>
      {([billing]) => (
        <Container {...props}>
          <CoinIcon />
          {toDecimal(billing.credits)}
        </Container>
      )}
    </Loader>
  );
};
